/**
 * Erros de negócio do backend chegam neste envelope:
 *
 * {
 *     "error": {
 *         "status_code": "E017001",
 *         "mensagem": "O usuário não é coordenador/subcoordenador do projeto...",
 *         "detalhes": { "usuario_id": 92 }
 *     }
 * }
 *
 * Eles podem vir com status 400/401 sem que a sessão tenha caído: o backend usa
 * 401 também para "sem permissão para este recurso". Por isso a presença do
 * envelope é o que diferencia um erro de negócio de uma sessão inválida.
 */
export const erroNegocio = (error) => {
    const dados = error?.response?.data?.error;

    return dados?.mensagem ? dados : null;
};

/**
 * Código do erro de negócio (ex.: "E019022"). O envelope usa `code` nos endpoints
 * novos e `status_code` nos antigos.
 */
export const codigoErroApi = (error) => {
    const dados = error?.response?.data?.error;

    return dados?.code ?? dados?.status_code ?? null;
};

/**
 * Marcado pelo interceptor do axios nos 400/401 em que ele já deslogou o usuário
 * e redirecionou para o login. Quem trata o erro só precisa exibir a mensagem.
 */
export const ehErroSessao = (error) => Boolean(error?.sessaoEncerrada);

/**
 * Erro que veio na esteira de outro já avisado ao usuário (a tela dispara vários
 * endpoints e todos voltam 401). Não deve gerar um novo toast.
 */
export const ehErroSilenciado = (error) => Boolean(error?.erroSilenciado);

/**
 * Mensagem a exibir para o usuário, priorizando o envelope de negócio e caindo
 * para o `detail` usado nos endpoints mais antigos. Retorna `null` quando o
 * backend não mandou nada aproveitável, para quem chamou usar o texto padrão.
 */
export const mensagemErroApi = (error) => {
    const negocio = erroNegocio(error);
    if (negocio) return negocio.mensagem;

    const dados = error?.response?.data;
    if (typeof dados?.detail === 'string') return dados.detail;
    if (typeof dados?.error === 'string') return dados.error;

    return null;
};
